import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgXtagclose = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 14,
	height: 14,
	viewBox: "0 0 14 14",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsx("circle", {
		cx: 6.9974,
		cy: 7.0013,
		r: 5.83333,
		stroke: "#FD8B81",
		strokeWidth: 1.2
	}), /* @__PURE__ */ _jsx("path", {
		d: "M8.45572 5.54298L5.53906 8.45964M5.53905 5.54297L8.4557 8.45962",
		stroke: "#CE0016",
		strokeWidth: 1.2,
		strokeLinecap: "round"
	})]
});
export default SvgXtagclose;
